/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
// string 관련 유틸리티

/*
 * desc : url 쿼리 문자열로 변경
 * param : Object
 */
export const queryStringfy = obj => {
  const str = [];
  Object.keys(obj).forEach(key => {
    if (obj[key]) {
      str.push(`${encodeURIComponent(key)}=${encodeURIComponent(obj[key])}`);
    }
  });

  return str.join('&');
};

/*
 * desc : 입력된 문자열이 url 패턴인지 체크
 * param : {
 *           str : String
 *         }
 */
export const checkPatternUrl = str => {
  const expUrl = /^(http\:\/\/)?((\w+)[.])+(asia|biz|cc|cn|com|de|eu|in|info|jobs|jp|kr|mobi|mx|name|net|nz|org|travel|tv|tw|uk|us)(\/(\w*))*$/i;
  return expUrl.test(str);
};
export default {
  queryStringfy,
  checkPatternUrl,
};



// WEBPACK FOOTER //
// ./src/utils/StringUtil.js